// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.TaskChat_chatContainer__d2\\+D1 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* НЕ 100vh */
  min-height: 360px;
  padding: 16px;
  background-color: var(--cl-surface-2);
  border-radius: 16px;
}

.TaskChat_chatMessages__\\+Htqz {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 12px;
  background-color: var(--cl-surface);
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  -webkit-user-select: text;
          user-select: text;
}

.TaskChat_message__63CRS {
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 12px;
  max-width: 72%;
  display: grid;
  gap: 10px;
}
.TaskChat_message__63CRS.TaskChat_myMessage__5s6kC {
  align-self: flex-end;
  background-color: rgba(34, 197, 94, 0.18);
}
.TaskChat_message__63CRS.TaskChat_otherMessage__uaRmr {
  align-self: flex-start;
  background-color: var(--cl-surface-2);
}

.TaskChat_emptyState__MzbtV {
  margin: auto;
  padding: 28px 20px;
  color: var(--cl-dark);
  opacity: 0.7;
  text-align: center;
}

.TaskChat_messageHeader__BGRjr {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: flex-start;
}

.TaskChat_messageAuthor__cfDG\\+ {
  font-weight: 700;
  font-size: 12px;
}

.TaskChat_messageBadges__0ePDG {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

.TaskChat_internalBadge__n2cox,
.TaskChat_mentionsBadge__HIvj5 {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.TaskChat_internalBadge__n2cox {
  background: rgba(245, 158, 11, 0.16);
  color: #92400e;
}

.TaskChat_mentionsBadge__HIvj5 {
  background: rgba(59, 130, 246, 0.14);
  color: #1d4ed8;
}

.TaskChat_messageText__8O10L {
  word-wrap: break-word;
  line-height: 1.5;
  -webkit-user-select: text;
          user-select: text;
  white-space: pre-wrap;
}
.TaskChat_messageText__8O10L li {
  margin-left: 15px;
}

.TaskChat_messageFiles__cDRG8 {
  display: grid;
  gap: 10px;
}

.TaskChat_messageFile__22t1\\+ {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.TaskChat_messageFile__22t1\\+ a {
  color: #007bff;
  text-decoration: none;
}
.TaskChat_messageFile__22t1\\+ a:hover {
  text-decoration: underline;
}

.TaskChat_previewAttachment__tA-Jl,
.TaskChat_fileAttachment__2XXq5 {
  width: min(320px, 100%);
  display: grid;
  gap: 8px;
  padding: 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.54);
  border: 1px solid rgba(148, 163, 184, 0.22);
}

.TaskChat_messageFileMeta__RXkiQ {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.TaskChat_messageFileName__AFOdP {
  font-size: 13px;
  color: var(--cl-dark);
  word-break: break-word;
}

.TaskChat_messageFooter__\\+vMT2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.TaskChat_messageTimestamp__IG59c {
  font-size: 12px;
  color: var(--cl-dark);
  opacity: 0.7;
}

.TaskChat_messageActions__XT\\+uD {
  display: flex;
  gap: 8px;
  align-items: center;
}
.TaskChat_messageActions__XT\\+uD button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: var(--cl-dark);
}

.TaskChat_chatInput__dnaOY {
  display: grid;
  gap: 10px;
}

.TaskChat_templateApplyError__8m2\\+3 {
  padding: 10px 12px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 13px;
  font-weight: 700;
}

.TaskChat_composerMeta__Zej2E {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.TaskChat_composerActions__fv2GL {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.TaskChat_messageInput__d2Ume {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--cl-border);
  background: var(--cl-surface);
  border-radius: 10px;
  min-height: 96px;
  resize: vertical;
}

.TaskChat_editMessageContainer__hgwTZ {
  display: grid;
  gap: 10px;
}

.TaskChat_editMessageInput__RK7e4 {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--cl-border);
  background: var(--cl-surface);
  border-radius: 10px;
  min-height: 96px;
  resize: vertical;
}

.TaskChat_editActions__9Gy3b {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.TaskChat_fileInputLabel__5AKyE {
  cursor: pointer;
  padding: 10px 12px;
  background-color: var(--cl-surface-2);
  border-radius: 10px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
}
.TaskChat_fileInputLabel__5AKyE:hover {
  opacity: 0.92;
}

.TaskChat_fileInput__YLQnj {
  display: none;
}

.TaskChat_templateButton__CHEtM,
.TaskChat_sendButton__oyPrN,
.TaskChat_saveEditButton__YAS9E,
.TaskChat_cancelEditButton__kxdYr {
  padding: 10px 14px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  min-height: 44px;
}

.TaskChat_templateButton__CHEtM,
.TaskChat_sendButton__oyPrN,
.TaskChat_saveEditButton__YAS9E {
  background-color: #007bff;
  color: white;
}
.TaskChat_templateButton__CHEtM:hover,
.TaskChat_sendButton__oyPrN:hover,
.TaskChat_saveEditButton__YAS9E:hover {
  background-color: #0056b3;
}
.TaskChat_templateButton__CHEtM:disabled,
.TaskChat_sendButton__oyPrN:disabled,
.TaskChat_saveEditButton__YAS9E:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.TaskChat_cancelEditButton__kxdYr {
  background: rgba(148, 163, 184, 0.18);
  color: var(--cl-dark);
}
.TaskChat_cancelEditButton__kxdYr:hover {
  background: rgba(148, 163, 184, 0.26);
}

.TaskChat_attachedFiles__owBz4 {
  display: grid;
  gap: 8px;
}
.TaskChat_attachedFiles__owBz4 .TaskChat_attachedFile__OdzQY {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.TaskChat_attachedFiles__owBz4 .TaskChat_progressBar__Gwvzm {
  width: 120px;
  height: 6px;
  background-color: #ccc;
  border-radius: 999px;
  overflow: hidden;
}
.TaskChat_attachedFiles__owBz4 .TaskChat_progressBar__Gwvzm .TaskChat_progressFill__uBF3q {
  height: 100%;
  background-color: #007bff;
  border-radius: 999px;
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.25) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.25) 50%, rgba(255, 255, 255, 0.25) 75%, transparent 75%, transparent);
  background-size: 18px 18px;
  animation: TaskChat_progressStripe__Wg4f3 0.9s linear infinite;
}
.TaskChat_attachedFiles__owBz4 .TaskChat_removeFileButton__hOSRr {
  background: none;
  border: none;
  cursor: pointer;
  color: #ff0000;
  font-size: 18px;
  line-height: 1;
}

@keyframes TaskChat_progressStripe__Wg4f3 {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 18px 0;
  }
}
/* Confirmation dialog */
.TaskChat_confirmationDialog__Kyu-z {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
}
.TaskChat_confirmationDialog__Kyu-z .TaskChat_confirmationContent__UkNly {
  background-color: var(--cl-surface);
  padding: 16px;
  border-radius: 12px;
  text-align: center;
  width: min(420px, 92vw);
}
.TaskChat_confirmationDialog__Kyu-z .TaskChat_confirmationContent__UkNly p {
  margin-bottom: 12px;
}
.TaskChat_confirmationDialog__Kyu-z .TaskChat_confirmationContent__UkNly button {
  padding: 10px 12px;
  margin: 0 6px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  min-height: 44px;
}
.TaskChat_confirmationDialog__Kyu-z .TaskChat_confirmationContent__UkNly button.TaskChat_confirmButton__qQk9\\+ {
  background-color: #ff0000;
  color: white;
}
.TaskChat_confirmationDialog__Kyu-z .TaskChat_confirmationContent__UkNly button.TaskChat_confirmButton__qQk9\\+:hover {
  background-color: #cc0000;
}
.TaskChat_confirmationDialog__Kyu-z .TaskChat_confirmationContent__UkNly button.TaskChat_cancelButton__MR25S {
  background-color: #ccc;
}
.TaskChat_confirmationDialog__Kyu-z .TaskChat_confirmationContent__UkNly button.TaskChat_cancelButton__MR25S:hover {
  background-color: #bbb;
}

/* Template modal (your custom modal) */
.TaskChat_modalOverlay__ls4VA {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2500;
  padding: 14px;
}

.TaskChat_modalContent__b32Ib {
  background-color: var(--cl-surface);
  padding: 16px;
  border-radius: 12px;
  width: min(600px, 96vw);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.TaskChat_templateListContainer__O2tDz {
  overflow-y: auto;
  max-height: 60vh;
  margin: 10px 0;
  padding-right: 10px;
}

.TaskChat_templateSearchInput__E0icZ {
  width: 100%;
  min-height: 40px;
  margin-top: 8px;
  padding: 9px 12px;
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 10px;
  background: var(--cl-surface, #fff);
  color: var(--cl-dark, #0f172a);
  font-size: 14px;
}
.TaskChat_templateSearchInput__E0icZ:focus {
  border-color: #007bff;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.14);
}

.TaskChat_templateList__PMLOF {
  list-style: none;
  padding: 0;
  margin: 0;
}

.TaskChat_templateItem__KU2r\\+ {
  padding: 10px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s;
}
.TaskChat_templateItem__KU2r\\+:hover {
  background-color: #f5f5f5;
}
.TaskChat_templateItem__KU2r\\+ strong {
  display: block;
  margin-bottom: 5px;
}
.TaskChat_templateItem__KU2r\\+ p {
  margin: 0;
  color: #666;
}

.TaskChat_templateEmptyState__Zt2yM {
  padding: 22px 12px;
  color: var(--cl-dark, #5f6b7a);
  text-align: center;
}

.TaskChat_closeModalButton__Ngfyr {
  align-self: flex-end;
  padding: 10px 12px;
  background-color: #f0f0f0;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  min-height: 44px;
}
.TaskChat_closeModalButton__Ngfyr:hover {
  background-color: #e0e0e0;
}

/* Mobile */
@media (max-width: 768px) {
  .TaskChat_chatContainer__d2\\+D1 {
    padding: 12px;
    border-radius: 14px;
  }
  .TaskChat_chatMessages__\\+Htqz {
    padding: 10px;
  }
  .TaskChat_message__63CRS {
    max-width: 92%;
  }
  .TaskChat_messageHeader__BGRjr,
  .TaskChat_messageFooter__\\+vMT2,
  .TaskChat_composerMeta__Zej2E,
  .TaskChat_composerActions__fv2GL,
  .TaskChat_messageFileMeta__RXkiQ,
  .TaskChat_editActions__9Gy3b {
    align-items: stretch;
    flex-direction: column;
  }
  .TaskChat_fileInputLabel__5AKyE,
  .TaskChat_templateButton__CHEtM,
  .TaskChat_sendButton__oyPrN,
  .TaskChat_saveEditButton__YAS9E,
  .TaskChat_cancelEditButton__kxdYr {
    width: 100%;
    justify-content: center;
  }
  .TaskChat_modalOverlay__ls4VA {
    align-items: flex-end;
    padding: 0;
  }
  .TaskChat_modalContent__b32Ib {
    width: 100%;
    max-height: calc(var(--vh, 1vh) * 100);
    border-radius: 16px 16px 0 0;
  }
  .TaskChat_templateListContainer__O2tDz {
    max-height: calc(var(--vh, 1vh) * 60);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/TaskChat/TaskChat.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,aAAA;EACA,iBAAA;EAEA,aAAA;EACA,qCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,0CAAA;EACA,yBAAA;UAAA,iBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AAAF;AAEE;EACE,oBAAA;EACA,yCAAA;AAAJ;AAGE;EACE,sBAAA;EACA,qCAAA;AADJ;;AAKA;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,QAAA;AAFF;;AAKA;;EAEE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,cAAA;AAFF;;AAKA;EACE,oCAAA;EACA,cAAA;AAFF;;AAKA;EACE,qBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qBAAA;AAFF;AAIE;EACE,iBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,SAAA;AAHF;;AAMA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAHF;AAKE;EACE,cAAA;EACA,qBAAA;AAHJ;AAKI;EACE,0BAAA;AAHN;;AAQA;;EAEE,uBAAA;EACA,aAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,2CAAA;AALF;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AALF;;AAQA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AALF;;AAQA;EACE,eAAA;EACA,qBAAA;EACA,YAAA;AALF;;AAQA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AALF;AAOE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;AALJ;;AASA;EACE,aAAA;EACA,SAAA;AANF;;AASA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AANF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,SAAA;AANF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AANF;;AASA;EACE,eAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AANF;AAQE;EACE,aAAA;AANJ;;AAUA;EACE,aAAA;AAPF;;AAUA;;;;EAIE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAPF;;AAUA;;;EAGE,yBAAA;EACA,YAAA;AAPF;AASE;;;EACE,yBAAA;AALJ;AAQE;;;EACE,sBAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,qCAAA;EACA,qBAAA;AALF;AAOE;EACE,qCAAA;AALJ;;AASA;EACE,aAAA;EACA,QAAA;AANF;AAQE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AANJ;AASE;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;AAPJ;AASI;EACE,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,qMAAA;EAUA,0BAAA;EACA,8DAAA;AAhBN;AAoBE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAlBJ;;AAsBA;EACE;IACE,wBAAA;EAnBF;EAqBA;IACE,2BAAA;EAnBF;AACF;AAsBA,wBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AApBF;AAsBE;EACE,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AApBJ;AAsBI;EACE,mBAAA;AApBN;AAuBI;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AArBN;AAuBM;EACE,yBAAA;EACA,YAAA;AArBR;AAuBQ;EACE,yBAAA;AArBV;AAyBM;EACE,sBAAA;AAvBR;AAyBQ;EACE,sBAAA;AAvBV;;AA8BA,uCAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AA3BF;;AA8BA;EACE,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2CAAA;EACA,mBAAA;EACA,mCAAA;EACA,8BAAA;EACA,eAAA;AA3BF;AA6BE;EACE,qBAAA;EACA,UAAA;EACA,6CAAA;AA3BJ;;AA+BA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,6BAAA;EACA,eAAA;EACA,iCAAA;AA5BF;AA8BE;EACE,yBAAA;AA5BJ;AA+BE;EACE,cAAA;EACA,kBAAA;AA7BJ;AAgCE;EACE,SAAA;EACA,WAAA;AA9BJ;;AAkCA;EACE,kBAAA;EACA,8BAAA;EACA,kBAAA;AA/BF;;AAkCA;EACE,oBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA/BF;AAiCE;EACE,yBAAA;AA/BJ;;AAmCA,WAAA;AACA;EACE;IACE,aAAA;IACA,mBAAA;EAhCF;EAmCA;IACE,aAAA;EAjCF;EAoCA;IACE,cAAA;EAlCF;EAqCA;;;;;;IAME,oBAAA;IACA,sBAAA;EAnCF;EAsCA;;;;;IAKE,WAAA;IACA,uBAAA;EApCF;EAuCA;IACE,qBAAA;IACA,UAAA;EArCF;EAwCA;IACE,WAAA;IACA,sCAAA;IACA,4BAAA;EAtCF;EAyCA;IACE,qCAAA;EAvCF;AACF","sourcesContent":[".chatContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  /* НЕ 100vh */\n  min-height: 360px;\n\n  padding: 16px;\n  background-color: var(--cl-surface-2);\n  border-radius: 16px;\n}\n\n.chatMessages {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 12px;\n  background-color: var(--cl-surface);\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);\n  user-select: text;\n}\n\n.message {\n  margin-bottom: 12px;\n  padding: 12px;\n  border-radius: 12px;\n  max-width: 72%;\n  display: grid;\n  gap: 10px;\n\n  &.myMessage {\n    align-self: flex-end;\n    background-color: rgba(34, 197, 94, 0.18);\n  }\n\n  &.otherMessage {\n    align-self: flex-start;\n    background-color: var(--cl-surface-2);\n  }\n}\n\n.emptyState {\n  margin: auto;\n  padding: 28px 20px;\n  color: var(--cl-dark);\n  opacity: 0.7;\n  text-align: center;\n}\n\n.messageHeader {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.messageAuthor {\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.messageBadges {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.internalBadge,\n.mentionsBadge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.internalBadge {\n  background: rgba(245, 158, 11, 0.16);\n  color: #92400e;\n}\n\n.mentionsBadge {\n  background: rgba(59, 130, 246, 0.14);\n  color: #1d4ed8;\n}\n\n.messageText {\n  word-wrap: break-word;\n  line-height: 1.5;\n  user-select: text;\n  white-space: pre-wrap;\n\n  li {\n    margin-left: 15px;\n  }\n}\n\n.messageFiles {\n  display: grid;\n  gap: 10px;\n}\n\n.messageFile {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n\n  a {\n    color: #007bff;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.previewAttachment,\n.fileAttachment {\n  width: min(320px, 100%);\n  display: grid;\n  gap: 8px;\n  padding: 10px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.54);\n  border: 1px solid rgba(148, 163, 184, 0.22);\n}\n\n.messageFileMeta {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.messageFileName {\n  font-size: 13px;\n  color: var(--cl-dark);\n  word-break: break-word;\n}\n\n.messageFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.messageTimestamp {\n  font-size: 12px;\n  color: var(--cl-dark);\n  opacity: 0.7;\n}\n\n.messageActions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n\n  button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    color: var(--cl-dark);\n  }\n}\n\n.chatInput {\n  display: grid;\n  gap: 10px;\n}\n\n.templateApplyError {\n  padding: 10px 12px;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.composerMeta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.composerActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.messageInput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--cl-border);\n  background: var(--cl-surface);\n  border-radius: 10px;\n  min-height: 96px;\n  resize: vertical;\n}\n\n.editMessageContainer {\n  display: grid;\n  gap: 10px;\n}\n\n.editMessageInput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--cl-border);\n  background: var(--cl-surface);\n  border-radius: 10px;\n  min-height: 96px;\n  resize: vertical;\n}\n\n.editActions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.fileInputLabel {\n  cursor: pointer;\n  padding: 10px 12px;\n  background-color: var(--cl-surface-2);\n  border-radius: 10px;\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n\n  &:hover {\n    opacity: 0.92;\n  }\n}\n\n.fileInput {\n  display: none;\n}\n\n.templateButton,\n.sendButton,\n.saveEditButton,\n.cancelEditButton {\n  padding: 10px 14px;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  min-height: 44px;\n}\n\n.templateButton,\n.sendButton,\n.saveEditButton {\n  background-color: #007bff;\n  color: white;\n\n  &:hover {\n    background-color: #0056b3;\n  }\n\n  &:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n  }\n}\n\n.cancelEditButton {\n  background: rgba(148, 163, 184, 0.18);\n  color: var(--cl-dark);\n\n  &:hover {\n    background: rgba(148, 163, 184, 0.26);\n  }\n}\n\n.attachedFiles {\n  display: grid;\n  gap: 8px;\n\n  .attachedFile {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n  }\n\n  .progressBar {\n    width: 120px;\n    height: 6px;\n    background-color: #ccc;\n    border-radius: 999px;\n    overflow: hidden;\n\n    .progressFill {\n      height: 100%;\n      background-color: #007bff;\n      border-radius: 999px;\n      background-image: linear-gradient(\n        45deg,\n        rgba(255, 255, 255, 0.25) 25%,\n        transparent 25%,\n        transparent 50%,\n        rgba(255, 255, 255, 0.25) 50%,\n        rgba(255, 255, 255, 0.25) 75%,\n        transparent 75%,\n        transparent\n      );\n      background-size: 18px 18px;\n      animation: progressStripe 0.9s linear infinite;\n    }\n  }\n\n  .removeFileButton {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #ff0000;\n    font-size: 18px;\n    line-height: 1;\n  }\n}\n\n@keyframes progressStripe {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: 18px 0;\n  }\n}\n\n/* Confirmation dialog */\n.confirmationDialog {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 3000;\n\n  .confirmationContent {\n    background-color: var(--cl-surface);\n    padding: 16px;\n    border-radius: 12px;\n    text-align: center;\n    width: min(420px, 92vw);\n\n    p {\n      margin-bottom: 12px;\n    }\n\n    button {\n      padding: 10px 12px;\n      margin: 0 6px;\n      border: none;\n      border-radius: 10px;\n      cursor: pointer;\n      min-height: 44px;\n\n      &.confirmButton {\n        background-color: #ff0000;\n        color: white;\n\n        &:hover {\n          background-color: #cc0000;\n        }\n      }\n\n      &.cancelButton {\n        background-color: #ccc;\n\n        &:hover {\n          background-color: #bbb;\n        }\n      }\n    }\n  }\n}\n\n/* Template modal (your custom modal) */\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2500;\n  padding: 14px;\n}\n\n.modalContent {\n  background-color: var(--cl-surface);\n  padding: 16px;\n  border-radius: 12px;\n  width: min(600px, 96vw);\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.templateListContainer {\n  overflow-y: auto;\n  max-height: 60vh;\n  margin: 10px 0;\n  padding-right: 10px;\n}\n\n.templateSearchInput {\n  width: 100%;\n  min-height: 40px;\n  margin-top: 8px;\n  padding: 9px 12px;\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 10px;\n  background: var(--cl-surface, #fff);\n  color: var(--cl-dark, #0f172a);\n  font-size: 14px;\n\n  &:focus {\n    border-color: #007bff;\n    outline: 0;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.14);\n  }\n}\n\n.templateList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.templateItem {\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background-color: #f5f5f5;\n  }\n\n  strong {\n    display: block;\n    margin-bottom: 5px;\n  }\n\n  p {\n    margin: 0;\n    color: #666;\n  }\n}\n\n.templateEmptyState {\n  padding: 22px 12px;\n  color: var(--cl-dark, #5f6b7a);\n  text-align: center;\n}\n\n.closeModalButton {\n  align-self: flex-end;\n  padding: 10px 12px;\n  background-color: #f0f0f0;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  min-height: 44px;\n\n  &:hover {\n    background-color: #e0e0e0;\n  }\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .chatContainer {\n    padding: 12px;\n    border-radius: 14px;\n  }\n\n  .chatMessages {\n    padding: 10px;\n  }\n\n  .message {\n    max-width: 92%;\n  }\n\n  .messageHeader,\n  .messageFooter,\n  .composerMeta,\n  .composerActions,\n  .messageFileMeta,\n  .editActions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .fileInputLabel,\n  .templateButton,\n  .sendButton,\n  .saveEditButton,\n  .cancelEditButton {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .modalOverlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .modalContent {\n    width: 100%;\n    max-height: calc(var(--vh, 1vh) * 100);\n    border-radius: 16px 16px 0 0;\n  }\n\n  .templateListContainer {\n    max-height: calc(var(--vh, 1vh) * 60);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatContainer": `TaskChat_chatContainer__d2+D1`,
	"chatMessages": `TaskChat_chatMessages__+Htqz`,
	"message": `TaskChat_message__63CRS`,
	"myMessage": `TaskChat_myMessage__5s6kC`,
	"otherMessage": `TaskChat_otherMessage__uaRmr`,
	"emptyState": `TaskChat_emptyState__MzbtV`,
	"messageHeader": `TaskChat_messageHeader__BGRjr`,
	"messageAuthor": `TaskChat_messageAuthor__cfDG+`,
	"messageBadges": `TaskChat_messageBadges__0ePDG`,
	"internalBadge": `TaskChat_internalBadge__n2cox`,
	"mentionsBadge": `TaskChat_mentionsBadge__HIvj5`,
	"messageText": `TaskChat_messageText__8O10L`,
	"messageFiles": `TaskChat_messageFiles__cDRG8`,
	"messageFile": `TaskChat_messageFile__22t1+`,
	"previewAttachment": `TaskChat_previewAttachment__tA-Jl`,
	"fileAttachment": `TaskChat_fileAttachment__2XXq5`,
	"messageFileMeta": `TaskChat_messageFileMeta__RXkiQ`,
	"messageFileName": `TaskChat_messageFileName__AFOdP`,
	"messageFooter": `TaskChat_messageFooter__+vMT2`,
	"messageTimestamp": `TaskChat_messageTimestamp__IG59c`,
	"messageActions": `TaskChat_messageActions__XT+uD`,
	"chatInput": `TaskChat_chatInput__dnaOY`,
	"templateApplyError": `TaskChat_templateApplyError__8m2+3`,
	"composerMeta": `TaskChat_composerMeta__Zej2E`,
	"composerActions": `TaskChat_composerActions__fv2GL`,
	"messageInput": `TaskChat_messageInput__d2Ume`,
	"editMessageContainer": `TaskChat_editMessageContainer__hgwTZ`,
	"editMessageInput": `TaskChat_editMessageInput__RK7e4`,
	"editActions": `TaskChat_editActions__9Gy3b`,
	"fileInputLabel": `TaskChat_fileInputLabel__5AKyE`,
	"fileInput": `TaskChat_fileInput__YLQnj`,
	"templateButton": `TaskChat_templateButton__CHEtM`,
	"sendButton": `TaskChat_sendButton__oyPrN`,
	"saveEditButton": `TaskChat_saveEditButton__YAS9E`,
	"cancelEditButton": `TaskChat_cancelEditButton__kxdYr`,
	"attachedFiles": `TaskChat_attachedFiles__owBz4`,
	"attachedFile": `TaskChat_attachedFile__OdzQY`,
	"progressBar": `TaskChat_progressBar__Gwvzm`,
	"progressFill": `TaskChat_progressFill__uBF3q`,
	"progressStripe": `TaskChat_progressStripe__Wg4f3`,
	"removeFileButton": `TaskChat_removeFileButton__hOSRr`,
	"confirmationDialog": `TaskChat_confirmationDialog__Kyu-z`,
	"confirmationContent": `TaskChat_confirmationContent__UkNly`,
	"confirmButton": `TaskChat_confirmButton__qQk9+`,
	"cancelButton": `TaskChat_cancelButton__MR25S`,
	"modalOverlay": `TaskChat_modalOverlay__ls4VA`,
	"modalContent": `TaskChat_modalContent__b32Ib`,
	"templateListContainer": `TaskChat_templateListContainer__O2tDz`,
	"templateSearchInput": `TaskChat_templateSearchInput__E0icZ`,
	"templateList": `TaskChat_templateList__PMLOF`,
	"templateItem": `TaskChat_templateItem__KU2r+`,
	"templateEmptyState": `TaskChat_templateEmptyState__Zt2yM`,
	"closeModalButton": `TaskChat_closeModalButton__Ngfyr`
};
export default ___CSS_LOADER_EXPORT___;
